import { useState } from 'react'
import { BsStar, BsStarFill } from 'react-icons/bs'
import { FbLink } from 'components/FbUI/FbLink'
import useApiService from '../services/api'

export function ContactStarToggle(props: {
  contactId: number
  contactName: string
  initialStarred: boolean
  /** When set, the name renders as a link to this route (same tab). */
  to?: string
}) {
  const api = useApiService()
  const [starred, setStarred] = useState(props.initialStarred)

  async function handleStar() {
    const previous = starred
    try {
      setStarred(!starred)
      const res = await api.contactStarToggle(props.contactId)
      setStarred(res)
    } catch (e) {
      setStarred(previous)
    }
  }

  return (
    <div className={'flex flex-row items-center gap-2'}>
      <button
        type="button"
        data-contact-star={starred ? 'on' : 'off'}
        onClick={handleStar}
        className="inline-flex h-5 w-5 cursor-pointer items-center justify-center rounded-full border-none bg-transparent p-0"
        aria-label={starred ? 'Unstar contact' : 'Star contact'}
      >
        {starred ? (
          <BsStarFill className="text-[#FFD582]" />
        ) : (
          <BsStar className="text-[#D0D3DD]" />
        )}
      </button>
      {props.to ? (
        <FbLink to={props.to} target="_self">
          {props.contactName}
        </FbLink>
      ) : (
        props.contactName
      )}
    </div>
  )
}
